import type { AffiliateAdvert, AffiliateAdvertApiResponse } from "../types"
import {
    getFiltersAsString,
    notOnlyCustomCategoriesActive,
    onlinserviceCategoryActive,
    telefonsexCategoryActive,
} from "./filter"
import { getAdvertsCardType } from "./get-advert-card-view-type"

let affiliateAdverts: AffiliateAdvertApiResponse

export const affiliateContainerElements = () =>
    document.querySelectorAll<HTMLInputElement>(".affiliate-card.ladies-card")

export async function updateAffiliateAdvertsInDom() {
    for (const element of Array.from(affiliateContainerElements())) {
        if (!affiliateAdverts?.content.length) {
            affiliateAdverts = await fetchAffiliateAdverts()
        }

        if (!affiliateAdverts?.content.length) {
            console.warn("Affiliate api returned an empty affiliate list. Did no generate affiliates?")
            break
        }

        const matched = element.className.match("card-(gallery|list)-(?<advertType>standard|premium)")
        if (matched?.groups) {
            const advertType = matched.groups.advertType as "premium" | "standard"
            const affiliateContentItem = affiliateAdverts.content.shift() as AffiliateAdvert

            if (userData.isLoggedIn) {
                const wrapper = document.createElement("div")
                wrapper.innerHTML = affiliateContentItem[advertType]

                const img = wrapper.querySelector(".ladies-card-close")
                if (img) img.remove()

                element.outerHTML = wrapper.innerHTML
                continue
            }

            element.outerHTML = affiliateContentItem[advertType]
        }
    }
}

export function setAffiliateAdverts(newAffiliateAdverts: AffiliateAdvertApiResponse) {
    affiliateAdverts = newAffiliateAdverts
}

export function getAffiliateAdverts() {
    return affiliateAdverts
}

export function createApiUrlForAffiliates() {
    let url = `/api/affiliates?filter=${getFiltersAsString()}&cardType=${getAdvertsCardType()}`

    if (notOnlyCustomCategoriesActive() || userData.isLoggedIn) {
        if (telefonsexCategoryActive()) {
            url += "&onlyTelefonsex=1"
        }
        if (onlinserviceCategoryActive()) {
            url += "&onlyOnlineservice=1"
        }
    }

    return url
}

export async function fetchAffiliateAdverts(): Promise<AffiliateAdvertApiResponse> {
    try {
        return await fetch(createApiUrlForAffiliates()).then((res) => res.json())
    } catch {
        return {
            content: [],
            count: 0,
        }
    }
}
;(async () => {
    setAffiliateAdverts(await fetchAffiliateAdverts())
    updateAffiliateAdvertsInDom()
})()
